// @flow
import { error } from './common';

import type { ID_TYPE } from '../types/common';
import * as types from '../types/routes';
import type { STUDENT_TYPE } from '../types/student';
import type {
  ROUTE_TYPE,
  ROUTE_STOP_TYPE,
  ROUTE_REMOVED_TYPE,
  ROUTE_SELECTED_TYPE,
  ROUTE_STOPS_FETCH_SUCCEED_TYPE,
  ROUTES_FETCH_STARTED_TYPE,
  ROUTE_DESELECTED_TYPE,
  ROUTES_FETCH_SUCCEED_TYPE,
  DELETE_ROUTE_STOP_STUDENT_STARTED_TYPE,
  ROUTE_FETCH_SUCCEED_TYPE,
  ROUTE_FETCH_STARTED_TYPE,
  ROUTES_UPDATE_SUCCEED_TYPE,
  ROUTE_UPDATED_TYPE,
  ROUTE_STOP_SELECTED_TYPE,
  ROUTE_STOP_UPDATED_TYPE,
  ROUTE_STOP_CONFIRMED_TYPE,
  ROUTE_STOPS_DESELECTED_TYPE,
  ROUTE_PATH_FETCH_STARTED_TYPE,
  ROUTE_STOPS_DETAIL_SHOWN_TYPE,
  ROUTE_STOPS_DETAIL_HIDDEN_TYPE,
  CREATE_ROUTE_STARTED_TYPE,
  CREATE_ROUTE_SUCCESS_TYPE,
  SORT_ROUTE_STOP_STARTED_TYPE,
  SORT_ROUTE_STOP_SUCCESS_TYPE,
  UPDATE_ROUTE_STARTED_TYPE,
  DELETE_ROUTE_STARTED_TYPE,
  DELETE_ROUTE_SUCCESS_TYPE,
  ROUTE_STOP_ADDED_TYPE,
  ROUTE_STOP_REMOVED_TYPE,
  ROUTE_STOP_STUDENTS_FETCH_STARTED_TYPE,
  ROUTE_STOP_STUDENTS_FETCH_SUCCEED_TYPE,
  ROUTE_STOP_STUDENT_ADDED_TYPE,
  SCHOOL_ROUTES_FETCH_STARTED_TYPE,
  UPDATE_VISIBLE_ROUTES_TYPE,
  DELETE_ROUTE_STOP_STUDENT_SUCCESS_TYPE,
  ROUTE_PATH_FETCH_SUCCEED_TYPE,
  ROUTE_STOPS_FETCH_STARTED_TYPE,
  ROUTE_STOP_FETCH_STARTED_TYPE,
  ROUTE_STOP_FETCH_SUCCEED_TYPE,
  ROUTE_TO_DELETE_TYPE,
  ROUTE_STOPS_STUDENT_ASSIGN_STARTED_TYPE,
  ROUTE_STOPS_STUDENT_ASSIGN_COMPLETED_TYPE,
} from '../types/routes';

export const startFetchRoutePath = (routeId: number): ROUTE_PATH_FETCH_STARTED_TYPE => ({
  type: types.ROUTE_PATH_FETCH_STARTED,
  payload: routeId,
});

export const fetchRoutePathSucceed = (
  id: number,
  route_path: Object,
): ROUTE_PATH_FETCH_SUCCEED_TYPE => ({
  type: types.ROUTE_PATH_FETCH_SUCCEED,
  payload: {
    id,
    route_path,
  },
});

export const startFetchRoutes = (schoolId: number): ROUTES_FETCH_STARTED_TYPE => ({
  type: types.ROUTES_FETCH_STARTED,
  payload: {
    schoolId,
  },
});

export const startFetchSchoolRoutes = (
  schoolId: number,
  text?: string,
): SCHOOL_ROUTES_FETCH_STARTED_TYPE => ({
  type: types.SCHOOL_ROUTES_FETCH_STARTED,
  payload: {
    schoolId,
    text,
  },
});

export const fetchRoutesSucceed = (
  entities: {[number]: ROUTE_TYPE},
  order: Array<number>,
): ROUTES_FETCH_SUCCEED_TYPE => ({
  type: types.ROUTES_FETCH_SUCCEED,
  payload: {
    entities,
    order,
  },
});

export const updateRoutesSucceed = (route: ROUTE_TYPE): ROUTES_UPDATE_SUCCEED_TYPE => ({
  type: types.ROUTES_UPDATE_SUCCEED,
  payload: route,
});

export const updateRoutesFailed = error(types.ROUTES_UPDATE_FAILED);
export const fetchRoutesFailed = error(types.ROUTES_FETCH_FAILED);

export const sortRouteFailed = error(types.SORT_STOP_FAILED);

export const createRouteFailed = error(types.CREATE_ROUTE_FAILED);

export const setCurrentRoute = (id: number): ROUTE_SELECTED_TYPE => ({
  type: types.ROUTE_SELECTED,
  payload: id,
});
export const clearCurrentRoute = (): ROUTE_DESELECTED_TYPE => ({
  type: types.ROUTE_DESELECTED,
});

export const setRouteToDelete = (id: number): ROUTE_TO_DELETE_TYPE => ({
  type: types.ROUTE_TO_DELETE,
  payload: id,
});

export const updateRouteStop = (routeStop: ROUTE_STOP_TYPE): ROUTE_STOP_UPDATED_TYPE => ({
  type: types.ROUTE_STOP_UPDATED,
  payload: routeStop,
});

export const addStudentToRouteStop = (
  routeStopId: number,
  student: STUDENT_TYPE,
): ROUTE_STOP_STUDENT_ADDED_TYPE => ({
  type: types.ROUTE_STOP_STUDENT_ADDED,
  payload: {
    id: routeStopId,
    student,
  },
});

export const startStudentAssignmentToStops = (
  stops: ROUTE_STOP_TYPE,
  student: ID_TYPE,
): ROUTE_STOPS_STUDENT_ASSIGN_STARTED_TYPE => ({
  type: types.ROUTE_STOPS_STUDENT_ASSIGN_STARTED,
  payload: {
    stops,
    student,
  }
});

export const completeStudentAssignmnetToStops = ( 
): ROUTE_STOPS_STUDENT_ASSIGN_COMPLETED_TYPE => ({
  type: types.ROUTE_STOPS_STUDENT_ASSIGN_COMPLETED,
});

export const failStudentAssignmnetToStops = error(types.ROUTE_STOPS_STUDENT_ASSIGN_FAILED);

export const confirmRouteStop = (
  oldId: ID_TYPE,
  newId: ID_TYPE,
  extra: Object = {},
): ROUTE_STOP_CONFIRMED_TYPE => ({
  type: types.ROUTE_STOP_CONFIRMED,
  payload: {
    ...extra,
    oldId,
    newId,
  },
});

export const setCurrentRouteStop = (id: number): ROUTE_STOP_SELECTED_TYPE => ({
  type: types.ROUTE_STOP_SELECTED,
  payload: id,
});

export const clearCurrentRouteStops = (): ROUTE_STOPS_DESELECTED_TYPE => ({
  type: types.ROUTE_STOPS_DESELECTED,
});

export const removeRoute = (id: number): ROUTE_REMOVED_TYPE => ({
  type: types.ROUTE_REMOVED,
  payload: id,
});

export const fetchRouteStarted = (id: number): ROUTE_FETCH_STARTED_TYPE => ({
  type: types.ROUTE_FETCH_STARTED,
  payload: id,
});

export const fetchRouteSucceed = (route: ROUTE_TYPE): ROUTE_FETCH_SUCCEED_TYPE => ({
  type: types.ROUTE_FETCH_SUCCEED,
  payload: route,
});

export const fetchRouteFailed = error(types.ROUTE_FETCH_FAILED);

export const fetchRouteStopStarted = (id: number): ROUTE_STOP_FETCH_STARTED_TYPE => ({
  type: types.ROUTE_STOP_FETCH_STARTED,
  payload: id,
});

export const fetchRouteStopSucceed = (
  routeStop: ROUTE_STOP_TYPE,
): ROUTE_STOP_FETCH_SUCCEED_TYPE => ({
  type: types.ROUTE_STOP_FETCH_SUCCEED,
  payload: routeStop,
});

export const fetchRouteStopFailed = error(types.ROUTE_STOP_FETCH_FAILED);

export const startFetchingRouteStops = (routeId: number): ROUTE_STOPS_FETCH_STARTED_TYPE => ({
  type: types.ROUTE_STOPS_FETCH_STARTED,
  payload: routeId,
});

export const fetchRouteStopsSucceed = (
  routeId: number,
  entities: {[number]: ROUTE_STOP_TYPE},
  order?: Array<number>,
  next?: number,
): ROUTE_STOPS_FETCH_SUCCEED_TYPE => ({
  type: types.ROUTE_STOPS_FETCH_SUCCEED,
  payload: {
    id: routeId,
    entities,
    order,
    next,
  },
});

export const updateVisibleRoutes = (visibleRoutes: Array<number>): UPDATE_VISIBLE_ROUTES_TYPE => ({
  type: types.UPDATE_VISIBLE_ROUTES,
  payload: visibleRoutes,
});

export const updateRoute = (id: number, attributes: Object): ROUTE_UPDATED_TYPE => ({
  type: types.ROUTE_UPDATED,
  payload: {
    id,
    ...attributes,
  },
});

export const showStopsDetail = (id: number): ROUTE_STOPS_DETAIL_SHOWN_TYPE => ({
  type: types.ROUTE_STOPS_DETAIL_SHOWN,
  payload: {
    id,
    isWatchingStopsDetail: true,
  },
});

export const hideStopsDetail = (id: number): ROUTE_STOPS_DETAIL_HIDDEN_TYPE => ({
  type: types.ROUTE_STOPS_DETAIL_HIDDEN,
  payload: {
    id,
    isWatchingStopsDetail: false,
  },
});

export const createRouteStarted = (
  name: string,
  type: string,
  monitor: number,
  driver: number,
  bus: number,
  week_days: Array<ID_TYPE>,
  expected_departure_time: string,
  expected_completion_time: string,
): CREATE_ROUTE_STARTED_TYPE => ({
  type: types.CREATE_ROUTE_STARTED,
  payload: {
    name,
    type,
    monitor,
    driver,
    bus,
    week_days,
    expected_departure_time,
    expected_completion_time,
  },
});

export const updateRouteStarted = (changed_route: ROUTE_TYPE): UPDATE_ROUTE_STARTED_TYPE => ({
  type: types.UPDATE_ROUTE_STARTED,
  payload: changed_route,
});

export const sortRouteStopStarted = (
  routeId: number,
  stopId: number,
  index: number,
): SORT_ROUTE_STOP_STARTED_TYPE => ({
  type: types.SORT_ROUTE_STOP_STARTED,
  payload: {
    routeId,
    stopId,
    index,
  },
});


export const deleteRouteStarted = (routeId: number): DELETE_ROUTE_STARTED_TYPE => ({
  type: types.DELETE_ROUTE_STARTED,
  payload: {
    routeId,
  },
});

export const deleteRouteSuccess = (route: { id: string }): DELETE_ROUTE_SUCCESS_TYPE => ({
  type: types.DELETE_ROUTE_SUCCESS,
  payload: route,
});

export const sortRouteStopSuccess = (route: ROUTE_TYPE): SORT_ROUTE_STOP_SUCCESS_TYPE => ({
  type: types.SORT_ROUTE_STOP_SUCCESS,
  payload: route,
});

export const createRouteSuccess = (route: ROUTE_TYPE): CREATE_ROUTE_SUCCESS_TYPE => ({
  type: types.CREATE_ROUTE_SUCCESS,
  payload: route,
});

export const addRouteStop = (routeStop: ROUTE_STOP_TYPE): ROUTE_STOP_ADDED_TYPE => ({
  type: types.ROUTE_STOP_ADDED,
  payload: routeStop,
});

export const removeRouteStop = (routeStopId: number): ROUTE_STOP_REMOVED_TYPE => ({
  type: types.ROUTE_STOP_REMOVED,
  payload: routeStopId,
});

export const startFetchingRouteStopStudents = (
  routeStopId: number,
): ROUTE_STOP_STUDENTS_FETCH_STARTED_TYPE => ({
  type: types.ROUTE_STOP_STUDENTS_FETCH_STARTED,
  payload: routeStopId,
});

export const deleteRouteStopStudentStarted = (
  routeStopId: number,
  studentId: number,
): DELETE_ROUTE_STOP_STUDENT_STARTED_TYPE => ({
  type: types.DELETE_ROUTE_STOP_STUDENT_STARTED,
  payload: {
    routeStopId,
    studentId,
  },
});

export const deleteRouteStopStudentSuccess = (
  routeStopId: number,
): DELETE_ROUTE_STOP_STUDENT_SUCCESS_TYPE => ({
  type: types.DELETE_ROUTE_STOP_STUDENT_SUCCESS,
  payload: routeStopId,
});

export const deleteRouteStopStudentFailed = error(types.ROUTE_STOP_STUDENTS_FETCH_FAILED);

export const completeRouteStopsStudentFetch = (
  routeStopId: number,
  order: Array<number>,
  entities: { [number]: STUDENT_TYPE},
): ROUTE_STOP_STUDENTS_FETCH_SUCCEED_TYPE => ({
  type: types.ROUTE_STOP_STUDENTS_FETCH_SUCCEED,
  payload: {
    id: routeStopId,
    order,
    entities,
  },
});

export const failRouteStopsStudentFetch = error(types.ROUTE_STOP_STUDENTS_FETCH_FAILED);



// WEBPACK FOOTER //
// ./src/scripts/actions/routes.js